import App from 'app/App';
import { Suspense } from 'react';
import { Router } from 'react-router-dom';
import { appHistory } from 'assets/hooks/pageRouter/AppHistory';
import * as serviceWorker from './serviceWorker';
import { loadConfig } from './config';

import { createRoot } from 'react-dom/client';
declare global {
  function gtag(
    command: 'config' | 'event' | 'js' | 'set' | 'consent',
    targetIdOrAction: string | Date,
    params?: Record<string, unknown>
  ): void;

  interface Window {
    gtag: typeof gtag;
    dataLayer: unknown[];
  }
}
loadConfig()
  .then(() => {
    const container = document.getElementById('root') as HTMLElement;
    const root = createRoot(container);

    root.render(
      <Suspense fallback="Loading...">
        <Router history={appHistory}>
          <App />
        </Router>
      </Suspense>
    );

    serviceWorker.unregister();
  })
  .catch((err) => {
    console.error(err);
    const container = document.getElementById('root') as HTMLElement;
    const root = createRoot(container);

    root.render(<div>Failed to load application configuration.</div>);

    serviceWorker.unregister();
  });
